import React, { useEffect, useState } from 'react';
import GoogleMapReact from 'google-map-react';

import Marker from './Marker';
import Social from './social';

import mapStyles from './styles';
import styles from './map.module.css';

const defaultProps = {
  center: {
    lat: 50.927,
    lng: 34.82,
  },
  zoom: 12,
};

const ViewOnMap = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, []);

  return (
    <div className={styles.wrapper}>
      <a href="/" className={styles.logoLink} />
      <Social customStyle={styles.social} />
      <GoogleMapReact
        options={{ styles: mapStyles }}
        bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_MAP_KEY }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        zoom={isMobile ? 12 : 13}
      >
        {/* <Marker lat={50.898368} lng={34.807651} /> */}
        <Marker lat={50.945833} lng={34.861861} name="Baranivska" />
      </GoogleMapReact>
    </div>
  );
};

export default ViewOnMap;
